import { useEffect } from "react";

type SeoArgs = {
  title: string;
  description?: string;
  jsonLd?: object;
};

export default function useSeo({ title, description, jsonLd }: SeoArgs) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      script.id = "__page_jsonld__";
      document.head.appendChild(script);
      return () => {
        const old = document.getElementById("__page_jsonld__");
        if (old) old.remove();
      };
    }
    return undefined;
  }, [title, description, jsonLd]);
}